import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Troop, UserType } from '../models';
import { ApplicantDocument } from '../models/Applicant';
import { AppConfig } from './../../core/config/app.config';
import { AppConfigConstants } from './../../core/config/app.config.constants';
import { ApplicationType, CodeValue, Country, County, EducationType, JobVacancySource, LawEnforcementTestType, MilitaryDischargeType, PATLocation, PATResult, Permission, PolygraphDisqualificationReason, Prefix, PsychologicalResult, Race, Role, RolePermission, Sex, StateAddress, Suffix, VeteranPreferenceClaimCategory, WaiverDocument } from './../../shared/models/lookup.models';
import { AppBaseHttpService } from './app-base-http.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http: HttpClient, private appBaseHttpService: AppBaseHttpService) { }

  get = {
    state: (): Observable<StateAddress[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/state');
      return this.appBaseHttpService.get(url);
    },

    county: (): Observable<County[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/county');
      return this.appBaseHttpService.get(url);
    },

    country: (): Observable<Country[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/country');
      return this.appBaseHttpService.get(url);
    },

    race: (): Observable<Race[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/race');
      return this.appBaseHttpService.get(url);
    },

    sex: (): Observable<Sex[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/sex');
      return this.appBaseHttpService.get(url);
    },

    prefix: (): Observable<Prefix[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/prefix');
      return this.appBaseHttpService.get(url);
    },

    suffix: (): Observable<Suffix[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/suffix');
      return this.appBaseHttpService.get(url);
    },

    militaryDischargeType: (): Observable<MilitaryDischargeType[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/militaryDischargeType');
      return this.appBaseHttpService.get(url);
    },

    jobVacancySource: (): Observable<JobVacancySource[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/jobVacancySource');
      return this.appBaseHttpService.get(url);
    },

    veteranPreferenceClaimCategory: (): Observable<VeteranPreferenceClaimCategory[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/veteranPreferenceClaimCategory');
      return this.appBaseHttpService.get(url);
    },


    userType: (): Observable<UserType[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/userType');
      return this.appBaseHttpService.get(url);
    },


    troop: (): Observable<Troop[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/troop');
      return this.appBaseHttpService.get(url);
    },

    applicantDocumentType: (): Observable<ApplicantDocument[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/applicantDocumentType');
      return this.appBaseHttpService.get(url);
    },

    patLocation: (): Observable<PATLocation[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/patLocation');
      return this.appBaseHttpService.get(url);
    },

    patPolygraphDisqualificationReason: (): Observable<PolygraphDisqualificationReason[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
        AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/polygraphDisqualificationReason');
      return this.appBaseHttpService.get(url);
    },

    psychologicalResult: (): Observable<PsychologicalResult[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
        AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/psychologicalResult');
      return this.appBaseHttpService.get(url);
    },

    patResult: (): Observable<PATResult[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
        AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/patResult');
      return this.appBaseHttpService.get(url);
    },

    //polygraphLocation: (): Observable<PolygraphLocation[]> => {
    //  const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    //  AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/polygraphLocation');
    //  return this.appBaseHttpService.get(url);
    //},

    role: (): Observable<Role[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/role');
      return this.appBaseHttpService.get(url);
    },

    permission: (): Observable<Permission[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/permission');
      return this.appBaseHttpService.get(url);
    },

    rolePermission: (): Observable<RolePermission[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/role-permission');
      return this.appBaseHttpService.get(url);
    },

    applicationType: (): Observable<ApplicationType[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/application-type');
      return this.appBaseHttpService.get(url);
    },

    educationType: (): Observable<EducationType[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/education-type');
      return this.appBaseHttpService.get(url);
    },

    waiverDocument: (): Observable<WaiverDocument[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/waiver-document');
      return this.appBaseHttpService.get(url);
    },

    lawEnforcementTestType: (): Observable<LawEnforcementTestType[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
        AppConfigConstants.LOOKUP_URL_SEGMENT]).concat('/law-enforcement-test-type');
      return this.appBaseHttpService.get(url);
    },

    codeValues: (): Observable<CodeValue[]> => {
      const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
        AppConfigConstants.LOOKUP_URL_SEGMENT]).concat(`/codes`);
      return this.appBaseHttpService.get(url);
    },
  }
}
